import React from 'react';
import { Stack } from 'library/ui';
import { WorkerTab } from 'parent-portal/home/new/components/WorkerTab';

import { hoursReported, actions } from './utils';

import type { TimesheetWorker, UnclockedInTimesheetWorker } from 'parent-portal/home/new/types';
import { CenterMissingPayment } from 'models';

export function SmallTimesheetsTable({
    data,
    editAction,
}: {
    data: TimesheetWorker[] | UnclockedInTimesheetWorker[] | CenterMissingPayment[];
    editAction: (worker: TimesheetWorker | UnclockedInTimesheetWorker | CenterMissingPayment) => void;
}) {
    return (
        <Stack gap="sm">
            {data.map((timesheet: TimesheetWorker | UnclockedInTimesheetWorker | CenterMissingPayment) => (
                <WorkerTab
                    key={`${timesheet.user.id}-${timesheet.start_date}`}
                    worker={{
                        user: timesheet.user,
                        profile_image: timesheet.profile_image,
                        ...hoursReported(timesheet),
                    }}
                    small={true}
                    onClick={() => editAction(timesheet)}
                    action={actions(timesheet, editAction, true)}
                />
            ))}
        </Stack>
    );
}
